import React from 'react';
import PropTypes from 'prop-types';

import Gauge from '../../library/gauge/gauge';

import './rating-gauge.scss';

function RatingGauge(props) {
  const { className, gaugeColor, label, rating, title } = props;
  return (
    <div className={`rating-gauge ${className || ''}`} styleName="container">
      {title && (
        <span className="rating-gauge__title" styleName="title">
          {title}
        </span>
      )}
      <Gauge
        className="rating-gauge__gauge"
        draw
        fillPerc={rating / 5}
        gaugeColor={gaugeColor}
        gaugeHeight={60}
        gaugeStrokeWidth={13}
        value={rating}
      />
      <span styleName="label">{label}</span>
    </div>
  );
}

RatingGauge.propTypes = {
  className: PropTypes.string,
  gaugeColor: PropTypes.string,
  label: PropTypes.string,
  rating: PropTypes.number,
  title: PropTypes.string
};

export default RatingGauge;
